var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('recommended-video',{attrs:{"title":"主播离线视频（匹配）"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }